import { Link } from "gatsby"
import React from "react"
import styled from 'styled-components'
import present from '../images/present.svg';

const StyledBanner = styled.div`
    display:flex;
    width:auto;
    max-width:400px;
    justify-content:center;
    border-radius:10px;
    margin:15px auto;
    background-color:var(--green-profile); 
    padding:.5rem .3rem;
   //mobil
    @media (max-width: 750px){
        font-size: 0.7rem;
    }
    span{
        color:white;
        font-weight:600;
    }
    
`

const Banner = () => {
    return (
        <StyledBanner>
        <Link to='/teme' className='banner'>
               <span>Nou: Teme săptămânale! &nbsp;</span> 
                       <img src={present} alt="present" width="30px"/>
          </Link>
        </StyledBanner>
    )

}

export default Banner;